const settingIcono = () => (
  <svg
  className="anticon anticon-setting ant-menu-item-icon"
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="square"
    strokeLinejoin="arcs"
    viewBox="0 0 60.000000 60.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,60.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
      <path
      fill="currentColor"
        d="M148 464 c-82 -41 -148 -79 -148 -84 0 -5 68 -44 151 -86 l152 -75
146 73 c91 45 146 79 146 88 0 14 -228 139 -280 153 -13 4 -71 -20 -167 -69z"
      />
      <path
            fill="currentColor"

        d="M553 303 c-9 -3 -13 -32 -13 -94 0 -52 -5 -97 -12 -109 -10 -15 -9
-26 5 -54 9 -20 21 -36 27 -36 6 0 18 16 27 36 14 28 15 39 5 54 -7 12 -12 58
-12 115 0 52 -3 95 -7 94 -5 0 -14 -3 -20 -6z"
      />
      <path
            fill="currentColor"

        d="M120 211 c0 -64 25 -96 92 -116 65 -19 111 -19 176 0 67 20 92 52 92
116 0 27 -2 49 -5 49 -3 0 -43 -19 -90 -42 l-85 -42 -85 42 c-47 23 -87 42
-90 42 -3 0 -5 -22 -5 -49z"
      />
    </g>
  </svg>
);

export default settingIcono;
